import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router-dom';

import { COGNITO_STATE } from 'utils/cognito.util';

class PrivateRoute extends Component {
  componentDidMount() {
    this.props.onDidMount && this.props.onDidMount();
  }

  componentWillUnmount() {
    this.props.onWillUnmount && this.props.onWillUnmount();
  }

  render() {
    const { component: Component, inProgress, isAuthenticated, ...rest } = this.props;

    if (inProgress) return <Route {...rest} render={() => <div> Loading ... </div>} />;

    if (isAuthenticated) return <Route {...rest} render={(props) => <Component {...props} />} />;

    return <Route {...rest} render={(props) => <Redirect to={{ pathname: '/', state: { from: props.location } }} />} />;
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.cognito.state === COGNITO_STATE.in,
  inProgress: state.cognito.state === COGNITO_STATE.loading,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
